import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Recipients, CampaignTabBar } from './components';
import useCampaign from './useCampaign';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const CampaignRecipients = props => {
  const campaign = useCampaign('/campaign/design', '/campaign/details');
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CampaignTabBar onTabChange={campaign.onTabChange} />
      <div className={classes.content}>
        <Recipients campaign={campaign} showNav={true} />
      </div>
    </div>
  );
};

export default CampaignRecipients;
